// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__1DDwY","load6":"Spinner__load6__3S2CE","round":"Spinner__round__2qdnM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 81
// module chunks = 16